document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formEliminarReporteAcondicionamiento') return;

    e.preventDefault();

    const formulario = e.target;
    const modalPadre = formulario.closest('.modal');
    const btnSubmit = formulario.querySelector('#btnEliminarReporteAcondicionamiento');
    const spinner = formulario.querySelector('#spinner');

    if (btnSubmit) btnSubmit.disabled = true;
    if (spinner) spinner.style.display = 'inline-block';

    try {
        const inputFormulario = formulario.querySelector('[name="idEncabezadoReporteAcondicionamiento"]');
        const inputReporteActivo = document.getElementById('idReporteAcondicionamiento');
        const idReporteActivo = inputReporteActivo ? inputReporteActivo.value : '';

        if (inputFormulario && !inputFormulario.value && idReporteActivo) {
            inputFormulario.value = idReporteActivo;
        }

        const formData = new FormData(formulario);

        const respuesta = await fetch('/api/acondicionamiento/eliminar', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        const json = await respuesta.json();

        if (!respuesta.ok || !json || !json.result) {
            if (typeof lanzarAlerta === 'function') lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            return;
        }

        const resultado = json.result;

        if (resultado.hayErrores) {
            if (Array.isArray(resultado.errores)) {
                resultado.errores.forEach(function (error) {
                    if (typeof lanzarAlerta === 'function') lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                });
            }
            return;
        }

        formulario.reset();

        if (modalPadre) modalPadre.classList.remove('modal--show');

        const modalReporte = document.querySelector('#modalProduccionAcondicionamiento');
        if (modalReporte) modalReporte.classList.remove('modal--show');

        const params = new URLSearchParams(window.location.search);
        if (typeof window.actualizarTablaAcondicionamientoPeriodo === 'function') {
            window.actualizarTablaAcondicionamientoPeriodo(params.get('mes'), params.get('año'));
        }
        if (typeof window.actualizarZonaTrabajo === 'function') {
            window.actualizarZonaTrabajo();
        }

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Orden de trabajo eliminada correctamente.', 'alerta-verde');
        }

    } catch (error) {
        console.error('Error:', error);
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } else {
            alert('Error crítico al procesar la solicitud.');
        }
    } finally {
        if (btnSubmit) btnSubmit.disabled = false;
        if (spinner) spinner.style.display = 'none';
    }
});
